<template>
  <client-only>
    <div
      :class="bindPaymentClass"
      v-show="isRenderPayment"
      :style="pcModuleBackColor"
    >
      <div class="payment-content-body" :style="moduleBackColor">
        <div class="title" :style="mFontColor" v-html="paymentTitleMsg"></div>
        <div class="payment-icon-list">
          <div
            v-for="(item, index) in paymentList"
            :class="['card', activeId === item.payMethod ? 'active' : '']"
            :key="index"
            @click="selectPayment(item)"
            :style="[
              activeId === item.payMethod ? payActiveBackColor : payBackColor,
            ]"
          >
            <div class="card-pad">
              <div class="trademark">
                <img v-lazy="item.logo" :alt="item.payMethodName" />
              </div>
              <div class="rt-info">
                <div class="prices">
                  <p class="info" :style="mFontColor">
                    {{ item.payMethodName || item.payMethod }}
                  </p>
                  <!-- 由于样式不同、只限于PC展示 -->
                  <p
                    v-if="renderDesktop(item)"
                    class="price"
                    :style="mFontColor"
                  >
                    {{ renderDesktopMassage(item) }}
                  </p>
                </div>
                <NEWPromotionTag
                  v-if="item.scriptConfig?.discountType"
                  :scriptConfig="item.scriptConfig"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="renderDropDown">
        <div
          :class="['put-away-centent', isOpen ? 'open' : '']"
          :style="mFontColor"
          @click="handleOpen"
        >
          <span>{{ isOpen ? foldText : unfoldText }}</span>
          <MBIcon
            :color="mFontColor.color"
            :size="iconArrowSize"
            name="icon-black-arrow"
          />
        </div>
      </template>
    </div>
  </client-only>
</template>
<script>
  import NEWPromotionTag from '../NEWPromotionTag'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import MBIcon from '@/components/MBIcon'
  import { storage } from '@/utils/storage'
  import { createdOrderNeedLoginGames } from '@page_detail/config'
  // import { mul } from '@/utils/accurateNumber'
  import { mapMutations, mapState, mapGetters } from 'vuex'

  let timer = null // 定时器
  export default {
    name: 'New-Reinforce-Payment',
    mixins: [styleConfiguration],
    props: {
      distributionOff: {
        type: Number,
        default: 0,
      },
    },
    components: {
      NEWPromotionTag,
      MBIcon,
    },
    data() {
      return {
        activeId: '',
        isOpen: true, // 下拉【展开状态】
        isRenderStow: false, // 是展示下拉按钮
        limit: 4,
        paymentList: [], // 需要渲染的支付列表
        isExcLimit: false, // 默认选中的支付通道索引是否超出了6
      }
    },

    destroyed() {
      clearTimeout(timer)
    },

    computed: {
      ...mapState([
        'isIAP',
        'gameName',
        'region',
        'selectedPaymentInfo',
        'selectedSkuInfo',
        'customGames',
        'myTaxRate',
        'isMobile',
        'isApp',
        'userInfo',
        'isGetapps',
        'isIAP',
        'isChromeBrowser',
        'isMiuiBrowser',
        'isTurbo',
        'isDesktop',
        'currency',
        'pubgmDiscount',
      ]),
      ...mapState('detail', ['payList', 'paymentChannel']),
      ...mapGetters([
        'selectedPaymentIdKey',
        'isAllExternalGames',
        'isRuStarMaker',
        'isEuropeCountry',
        'isRuPubgm',
      ]),
      renderDropDown() {
        return this.isDesktop && this.mergePaymentList?.length > 4
      },
      iconArrowSize() {
        return this.isDesktop ? 14 : 40
      },
      foldText() {
        return this.$t(`publicDetails.fold`)
      },

      unfoldText() {
        return this.$t(`publicDetails.unfold`)
      },

      channelTitle() {
        const fgame = this.isRuStarMaker ? 'publicDetails' : this.gameName
        const channelTitleKey = this.$te(`${fgame}.channel_title`)
        const channelTitle = channelTitleKey
          ? this.$t(`${fgame}.channel_title`)
          : this.$t(`publicDetails.channel_title`)

        return channelTitle
      },
      paymentTitleMsg() {
        const isHackRes = createdOrderNeedLoginGames.includes(this.gameName)
        if (this.uidModuleType === 6) return `3.&nbsp;${this.channelTitle}`
        if (this.awardType !== 2) return `2.&nbsp;${this.channelTitle}`

        return isHackRes
          ? `2.&nbsp;${this.channelTitle}`
          : `3.&nbsp;${this.channelTitle}`
      },

      isRenderPayment() {
        if (this.isIAP) return false
        if (this.paymentList.length === 0) return false
        return true
      },
      payActiveBackColor() {
        if (this.isMobile) {
          return {
            color: this.skuActiveBackColor.borderColor,
          }
        }
        return this.skuActiveBackColor
      },
      bindPaymentClass() {
        const defaultClass = ['payment-content']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device = `${defaultClass[0]}-mobile`
        }
        if (this.isApp) {
          device = `${defaultClass[0]}-app`
        }

        return defaultClass.concat(device)
      },

      distributorTagShow() {
        return !!(this.isDistributor && this.distributionOff)
      },

      // warn: 某些游戏如果需要当前国家支持的全部支付通道兜底
      mergePaymentList() {
        if (this.skuType === 1) return this.paymentChannel
        if (this.skuType === 2) {
          return this.paymentChannel.length ? this.paymentChannel : this.payList
        }
        return []
      },
    },
    watch: {
      mergePaymentList: {
        handler(newVal) {
          if (!newVal.length) {
            this['detail/setCheckChannelItem']({})
            this.isRenderStow = false
            this.paymentList = []
          } else {
            const status = newVal.length > this.limit
            this.isRenderStow = status

            this.togglePayList(status, 'init')
            this.isExceedlimitlist(status, newVal)
            this.selectedChannelItem(newVal)
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      ...mapMutations(['detail/setCheckChannelItem']),

      formatPrice(price) {
        return this.$options.filters['formatMoney'](price)
      },

      // 如果默认选中的支付通道大于6， 默认全部展开、
      isExceedlimitlist(state, payList) {
        if (!state) return

        const cacheKey = this.paymentIdKey()
        const cindex = payList.findIndex((item) => item.payMethod === cacheKey)
        const result = cindex > this.limit - 1

        if (this.isMobile) {
          this.paymentList = this.mergePaymentList
        }

        if (this.isDesktop && result) {
          this.paymentList = this.mergePaymentList
        }

        this.isOpen = result
      },
      selectedChannelItem(clist) {
        const cacheKey = this.paymentIdKey()
        const result = clist.find((item) => item.payMethod === cacheKey)

        // 默认选择第一个同时更新VUEX
        if (!result) {
          this.activeId = clist[0].payMethod
          this['detail/setCheckChannelItem'](clist[0])
        } else {
          this.activeId = cacheKey
          this['detail/setCheckChannelItem'](result)
        }
      },
      handleOpen() {
        this.isOpen = !this.isOpen
        this.togglePayList(this.isOpen, 'click')
      },
      /**
       * @description:  展开收起
       * @param {Boolean} state
       * @param {String} type 类型、是否是初始渲染、还是点击事件
       * @return {Null}
       */
      togglePayList(state, type = 'click') {
        const _state = type === 'init' ? (state = !state) : state

        if (_state) {
          this.paymentList = this.mergePaymentList
        } else {
          this.paymentList = this.mergePaymentList.filter(
            (_, index) => index <= this.limit - 1
          )
        }
      },
      paymentIdKey(value = '') {
        if (value) {
          storage.set(this.selectedPaymentIdKey, value)
        }
        return storage.get(this.selectedPaymentIdKey)
      },

      selectPayment(item) {
        this.isAwardTypeScroll()
        this['detail/setCheckChannelItem'](item)
        this.paymentIdKey(item.payMethod)
        this.activeId = item.payMethod
      },

      isAwardTypeScroll() {
        if ([1, 3].includes(this.awardType)) return
        this.scrollSpecifiedPosition()
      },

      // 切换支付方式 滚动到UID区域
      scrollSpecifiedPosition() {
        const input =
          document.querySelector('#uid-input') ||
          document.querySelector('#check-uid-input') ||
          null

        const roots = document.querySelector('html')

        if (!input) return
        if (input && input.value.trim() !== '') return

        clearTimeout(timer)

        roots.scrollIntoView({ behavior: 'smooth' })

        timer = setTimeout(() => {
          input.focus({ preventScroll: false })
        }, 300)
      },
      // 钱包显示优惠信息
      walletShowTag(item) {
        return item.payMethodName === 'K-Wallet' && !this.distributorTagShow
      },
      // 钱包分享优惠信息
      walletDistributorTag(item) {
        return item.payMethodName === 'K-Wallet'
      },

      renderDesktop(item) {
        const price = item.pay_price || item.channelPrice
        return price > 0 && this.isDesktop
      },
      renderDesktopMassage(item) {
        const price = item.pay_price || item.channelPrice
        const _price = this.formatPrice(price)

        if (this.isEuropeCountry) {
          const hackPrice = this.hackDesktopPrice(price)
          const _hackPrice = this.formatPrice(hackPrice)
          return `${_hackPrice} ${this.currency}`
        }

        return `${this.currency} ${_price}`
      },
      hackDesktopPrice(pre) {
        // if (this.isRuPubgm) return Math.ceil(mul(pre, this.pubgmDiscount))
        return pre
      },
    },
  }
</script>

<style lang="scss" scoped src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 1000px) {
    @import './1000.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
